// Shared shape for community feed posts, kept local to the community UI so the
// page and its presentational components agree on one definition.
export interface FeedPost {
  id: string;
  userId: string;
  displayName: string;
  avatarUrl: string | null;
  contentType: 'image' | 'video';
  mediaUrl: string;
  thumbnailUrl: string | null;
  caption: string;
  tags: string[];
  likesCount: number;
  commentsCount: number;
  liked: boolean;
  isFeatured: boolean;
  prompt: string | null;
  showPrompt: boolean;
  createdAt: string;
}

export type TabKey = 'foryou' | 'following' | 'trending';
export type SortKey = 'recent' | 'trending' | 'featured';

export function initials(name: string) {
  return name ? name.slice(0, 2).toUpperCase() : '?';
}

export function formatCount(n: number) {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return n.toString();
}

export function timeAgo(date: string) {
  const s = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  if (s < 60) return 'now';
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  if (s < 604800) return `${Math.floor(s / 86400)}d`;
  return `${Math.floor(s / 604800)}w`;
}
